export default "__VITE_ASSET__DXB3UWPh__"